import React, { useState } from "react";
import { IoSearch } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdAddCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import AddCustomer from "./partials/AddCustomer";
import CustomerList from "./partials/CustomerList";
import BulkCustomerUploadModal from "./partials/BulkCustomerUploadModal";

export default function Customer() {
  const [searchTerm, setSearchTerm] = useState("");
  const [listKey, setListKey] = useState(0);

  return (
    <div>
      <div className="mx-3 mt-4">
        <div className="dashboard-header d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
          <div className="pageTitle">
            <h1>Customers</h1>
          </div>

          <div className="dashboard-actions d-flex align-items-center gap-3">
            <div className="new-customer-trigger d-flex gap-3">
              <BulkCustomerUploadModal onUploadComplete={() => setListKey(k => k + 1)} />
              <AddCustomer type="add" />
            </div>
          </div>
        </div>
        <CustomerList key={listKey} searchTerm={searchTerm} />
      </div>
    </div>
  );
}
